import "whatwg-fetch"; // polyfill for older browsers
import {
  getAPIConfig,
  convertQueryObjToString,
  handleAPIResponse,
} from "@utils/browser-helpers";
import { executeAPIRequest } from "@adapters/api";

var storesAdapter = {
  fetchAllStores: async (fetchConfig) => {
    let route = `/stores${
      fetchConfig ? `${convertQueryObjToString(fetchConfig, true)}` : ""
    }`;
    const apiConfig = getAPIConfig(route);
    const response = await executeAPIRequest(apiConfig, "GET");
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },
  fetchByStoreStatus: async (storeStatus) => {
    let route = `/stores${storeStatus ? `/${storeStatus}` : ""}`;
    const apiConfig = getAPIConfig(route);
    const response = await executeAPIRequest(apiConfig, "GET");
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },
  fetchIndividualStore: async (storeId) => {
    let route = `/stores/id/${storeId}`;
    const apiConfig = getAPIConfig(route);
    const response = await executeAPIRequest(apiConfig, "GET");
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },

  postNewStore: async (changes) => {
    const apiConfig = getAPIConfig(`/stores/id`);
    const response = await executeAPIRequest(apiConfig, "POST", null, changes);
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },

  patchStore: async (storeId, changes) => {
    const apiConfig = getAPIConfig(`/stores/id/${storeId}`);
    const response = await executeAPIRequest(apiConfig, "PATCH", null, changes);
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },
  deleteStore: async (storeId) => {
    const apiConfig = getAPIConfig(`/stores/id/${storeId}`);
    const response = await executeAPIRequest(apiConfig, "DELETE");
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },
};

window.storesAdapter = storesAdapter;

export default storesAdapter;
